
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Grundsätzlich gilt: Jeder Mensch hat einen ganz individuellen Schlafbedarf. Es gibt aber Referenzwerte: Die US-amerikanische National Health Foundation hat `}<Link href="https://www.sleephealthjournal.org/article/S2352-7218%2815%2900015-7/fulltext" mdxType="Link">{`Richtlinien`}</Link>{` herausgegeben, die auch für Europa gelten sollen. Wichtig zu wissen ist: Nicht nur zu wenig Schlaf verschlechtert unsere Gesundheit, sondern auch zu viel.`}</p>
    <Image file={['images/viz_sleepinghours_mob.svg', 'images/viz_sleepinghours_mob.svg']} title={'Ideale Schlafdauer nach Alter'} source='brs' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;